import PropTypes from 'prop-types';
import { useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';

// project import
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import MiniDrawerStyled from './MiniDrawerStyled';
import { drawerWidth } from 'config';
import { reactLocalStorage } from 'reactjs-localstorage';
import { WBLabel } from 'components/_WBcomponents/WBLabel';
import { useNavigate } from 'react-router';

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

const currWindow = window

const MainDrawer = ({ open, handleDrawerToggle, window }) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));
  const navigate = useNavigate()
  const version = "v 1.4.0"

  // responsive drawer container
  const container = window !== undefined ? () => window().document.body : undefined;

  // header content
  const drawerContent = useMemo(() => <DrawerContent />, []);
  const drawerHeader = useMemo(() => <DrawerHeader open={open} />, [open]);

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1300 }}>
      {!matchDownMD ? (
        <MiniDrawerStyled variant="permanent" open={open}>
          {drawerHeader}
          {drawerContent}
          <div style={{ padding: 28, cursor: 'pointer', bottom: 0}}>
            <div onClick={() => { navigate(`/profile`) }}>
              <WBLabel bold style={{
                marginBottom: 10
              }}>Profile</WBLabel>
            </div>
            <div onClick={() => {
              reactLocalStorage.clear()
              currWindow.location.href = "/"
            }}>
              <WBLabel bold style={{
                marginBottom: 10
              }}>Logout</WBLabel>
            </div>
            <WBLabel subtitle style={{
              marginBottom: -10
            }}>{version}</WBLabel>
          </div>
        </MiniDrawerStyled>
      ) : (
        <Drawer
          container={container}
          variant="temporary"
          open={open}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', lg: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              borderRight: `1px solid ${theme.palette.divider}`,
              backgroundImage: 'none',
              boxShadow: 'inherit'
            }
          }}
        >
          {open && drawerHeader}
          {open && drawerContent}
          <div style={{ padding: 28, cursor: 'pointer', bottom: 0}}>
            <div onClick={() => { navigate(`/profile`) }}>
              <WBLabel bold style={{
                marginBottom: 10
              }}>Profile</WBLabel>
            </div>
            <div onClick={() => {
              reactLocalStorage.clear()
              currWindow.location.href = "/"
            }}>
              <WBLabel bold style={{
                marginBottom: 10
              }}>Logout</WBLabel>
            </div>
            <WBLabel subtitle style={{
              marginBottom: -10
            }}>{version}</WBLabel>
          </div>
        </Drawer>
      )}
    </Box>
  );
};

MainDrawer.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  window: PropTypes.object
};

export default MainDrawer;
